import axios from 'api';

// /api/super/reference/template-points/
// Backend filterset: { scope, datatype, is_in_llm } (all exact). Search: name.

export const getTemplatePointData = (filtersData, signal) => {
  const { page_size, page, search, scope, datatype, is_in_llm } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (scope) params.set('scope', scope);
  if (datatype) params.set('datatype', datatype);
  if (is_in_llm != null && is_in_llm !== '') params.set('is_in_llm', is_in_llm);
  return axios.get(`/api/super/reference/template-points/?${params.toString()}`, { signal });
};

export const createTemplatePoint = (params) => {
  return axios.post(`/api/super/reference/template-points/`, params);
};

export const updateTemplatePoint = (params) => {
  return axios.patch(`/api/super/reference/template-points/${params.id}/`, params);
};

export const deleteTemplatePoint = (id) => {
  return axios.delete(`/api/super/reference/template-points/${id}/`);
};

export const getAllTemplatePoints = () => {
  return axios.get(`/api/super/reference/template-points/?page_size=1000`);
};

// /api/super/reference/use-cases/
// Backend filterset: { scope: ["exact"] }. Search: name, description.

export const getUseCaseData = (filtersData, signal) => {
  const { page_size, page, search, scope } = filtersData || {};
  const params = new URLSearchParams();
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  if (search) params.set('search', search);
  if (scope) params.set('scope', scope);
  return axios.get(`/api/super/reference/use-cases/?${params.toString()}`, { signal });
};

export const createUseCase = (params) => {
  return axios.post(`/api/super/reference/use-cases/`, params);
};

export const updateUseCase = (params) => {
  return axios.patch(`/api/super/reference/use-cases/${params.id}/`, params);
};

export const deleteUseCase = (id) => {
  return axios.delete(`/api/super/reference/use-cases/${id}/`);
};

export const getAllPublicUseCases = () => {
  return axios.get(`/api/super/reference/use-cases/?page_size=1000`);
};

// /api/super/reference/template-points-values/
// Backend filterset: { template_point: ["exact"], usecase: ["exact"] }.
// Accepts either { id } (legacy — treated as usecase) or { usecase, template_point }.

export const getTemplateValuesData = (filtersData, signal) => {
  const { id, usecase, template_point, page_size, page } = filtersData || {};
  const params = new URLSearchParams();
  const usecaseFilter = usecase ?? id;
  if (usecaseFilter != null && usecaseFilter !== '') params.set('usecase', usecaseFilter);
  if (template_point != null && template_point !== '') params.set('template_point', template_point);
  if (page_size != null) params.set('page_size', page_size);
  if (page != null) params.set('page', page);
  return axios.get(`/api/super/reference/template-points-values/?${params.toString()}`, { signal });
};

export const updateTemplateValues = (params) => {
  return axios.patch(`/api/super/reference/template-points-values/${params.id}/`, params);
};

// ─── Legacy stubs ────────────────────────────────────────────────────────
import { removedStub } from 'api/_legacy';
export const getCustomerUseCaseData = removedStub('getCustomerUseCaseData');
export const createCustomerUseCase = removedStub('createCustomerUseCase');
export const updateCustomerUseCase = removedStub('updateCustomerUseCase');
export const deleteCustomerUseCase = removedStub('deleteCustomerUseCase');
export const getAllLLMVendors = removedStub('getAllLLMVendors');
export const getAllLLMVendorModels = removedStub('getAllLLMVendorModels');
